import FetchService from '../services/fetchService';
import urlService from '../services/urlService';
import { updatePaymentDescription } from './updatePaymentDescription';

const addPayments = ({
  inst,
  paymentData,
  setIsIframeLoaded,
  setLoading,
  setIsCardValid,
  bookRide,
  updatePayment,
  updatePaymentMethodId,
  updateStep,
  updateEditor,
  updatePreviousStep,
  state,
  setUpdatePaymentsMenu,
}) => {
  const {
    step,
    isWebBooker,
    userId,
    applePayPaymentMethod,
    payPalPaymentMethod,
    userProfile: { first_name = '', last_name = '' } = {},
    editor,
    previousStep,
  } = state;
  const name_on_card = `${first_name?.toUpperCase()}${first_name ? ' ' : ''}${last_name?.toUpperCase()}` || 'TEST USER';
  let data = {
    associated_entity_id: userId || '',
    name_on_card,
    active: !!isWebBooker,
  };

  if (paymentData.isApplePay) {
    data.associated_entity_type = 'user';
    data.payment_type = 'apple_pay';
    data.tokens = [
      {
        type: 'veripay',
        values: {
          card_token: paymentData.token,
          exp_month: 12,
          exp_year: 2025,
          linked_payment_method_id: isWebBooker && applePayPaymentMethod ? applePayPaymentMethod : null,
        },
      },
    ];
  } else if (paymentData.isPayPal) {
    data.payment_type = 'paypal';
    data.tokens = [
      {
        type: 'veripay',
        values: {
          card_token: paymentData.token,
          exp_month: 12,
          exp_year: 2025,
          linked_payment_method_id: isWebBooker && payPalPaymentMethod ? payPalPaymentMethod : null,
        },
      },
    ];
  } else {
    data.payment_type = 'credit_card';
    data.tokens = [
      {
        type: 'veripay',
        values: {
          card_token: paymentData.token,
        },
      },
    ];
  }

  return FetchService.getWebApiResource(urlService.addPaymentMethod(data))
    .then(response => {
      response.description = updatePaymentDescription(response);

      if (response.type === 'credit_card') {
        const card = inst.collectCardData();
        response.card_number = card.card_number;
        response.exp_date = card.exp_date;
        response.zip = card.zip;
        response.cvv = card.cvv;
      }

      updatePayment(response);
      updatePaymentMethodId(response.id);
      if (setIsIframeLoaded) {
        setIsIframeLoaded(false);
      }
      if (setLoading) {
        setLoading(false);
      }
      if (setIsCardValid) {
        setIsCardValid(false);
      }

      if (bookRide) {
        bookRide();
      } else {
        const st = step;
        setUpdatePaymentsMenu(true);
        if (editor?.isOpenedFromMenu) {
          updateStep(previousStep);
          updatePreviousStep('');
        } else if (previousStep) {
          updateStep(previousStep);
          updatePreviousStep('');
        } else {
          updateStep(st + 1);
        }
        updateEditor('');
      }

      console.log('Payments has been successfully added ', response);
    })
    .catch(error => {
      if (setIsIframeLoaded) {
        setIsIframeLoaded(false);
      }
      if (setLoading) {
        setLoading(false);
      }
      if (setIsCardValid) {
        setIsCardValid(false);
      }

      updatePayment({});
      updatePaymentMethodId(null);
      console.log('Add payments invalid ', error);
    });
};

export default addPayments;
